import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfig } from "./auth";


import { GET_DASHBOARD } from "./types";



// GET ALL DASHBOARD CONTENT
export const getDashboard = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/dashboard/get-dashboard-summary`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_DASHBOARD,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
}